import React from 'react';
import { motion } from 'framer-motion';
import './Gallery.css';
import bikeImage from '../assets/bike.jpg';
import waterImage from '../assets/water.jpg';
import profileImage from '../assets/pashupati nath.jpg';

const Gallery = () => {
  const galleryItems = [
    {
      id: 1,
      image: bikeImage,
      title: 'Adventure Awaits',
      category: 'Adventure',
      description: 'Embracing new challenges and exploring new horizons'
    },
    {
      id: 2,
      image: waterImage,
      title: 'Nature\'s Beauty',
      category: 'Nature',
      description: 'Finding inspiration and peace in nature'
    },
    {
      id: 3,
      image: profileImage,
      title: 'Professional Growth',
      category: 'Work',
      description: 'Dedicated to excellence in every endeavor'
    },
    {
      id: 4,
      image: bikeImage,
      title: 'Outdoor Exploration',
      category: 'Travel',
      description: 'Discovering new places and cultures'
    },
    {
      id: 5,
      image: waterImage,
      title: 'Peaceful Moments',
      category: 'Lifestyle',
      description: 'Cherishing moments of tranquility'
    },
    {
      id: 6,
      image: profileImage,
      title: 'Tech Innovation',
      category: 'Work',
      description: 'Building the future with technology'
    },
    {
      id: 7,
      image: bikeImage,
      title: 'Journey Continues',
      category: 'Adventure',
      description: 'Every day brings new opportunities'
    },
    {
      id: 8,
      image: waterImage,
      title: 'Reflection Time',
      category: 'Lifestyle',
      description: 'Moments for personal reflection and growth'
    },
    {
      id: 9,
      image: profileImage,
      title: 'Success Milestone',
      category: 'Work',
      description: 'Celebrating achievements and milestones'
    }
  ];

  const [selectedCategory, setSelectedCategory] = React.useState('All');

  const categories = ['All', 'Adventure', 'Nature', 'Work', 'Travel', 'Lifestyle'];

  const filteredItems = selectedCategory === 'All'
    ? galleryItems
    : galleryItems.filter(item => item.category === selectedCategory);

  return (
    <motion.div
      className="gallery"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="container">
        <motion.div
          className="gallery-header"
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          <h2>My Gallery</h2>
          <p>Daily life experiences and memorable moments</p>
        </motion.div>

        <motion.div
          className="gallery-filters"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          {categories.map((cat) => (
            <button
              key={cat}
              className={`filter-btn ${selectedCategory === cat ? 'active' : ''}`}
              onClick={() => setSelectedCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </motion.div>

        <div className="gallery-grid">
          {filteredItems.map((item, index) => (
            <motion.div
              key={item.id}
              className="gallery-item"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.05, duration: 0.5 }}
              layout
            >
              <div className="gallery-image-wrapper">
                <img src={item.image} alt={item.title} />
                <div className="gallery-overlay">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Gallery;